import React from "react";
import { capitalize } from "../../../../../../utils/helpers";

const PitchDeckTableRowView = ({
  fieldName,
  data,
  displayName = fieldName,
  className,
  unitName,
  displayUnit,
  renderContent,
}) => {
  return (
    <>
      {unitName ? (
        <tr className="idea-checker-table-row">
          <th className="idea-checker-table-data-left companytitlecard">
            {capitalize(displayName)}
          </th>
          <td colSpan={2} className="idea-checker-table-data-right">
            {!data[fieldName] && !data[unitName]
              ? "-"
              : "USD" + data[fieldName] + " " + data[unitName]}
          </td>
        </tr>
      ) : (
        <tr className="idea-checker-table-row">
          <th className="idea-checker-table-data-left companytitlecard">
            {displayName}
          </th>
          <td colSpan={2} className="idea-checker-table-data-right">
            {renderContent
              ? renderContent
              : !data[fieldName]
                ? "-"
                : displayUnit === "%"
                  ? data[fieldName] + displayUnit
                  : data[fieldName] + " " + displayUnit}
          </td>
        </tr>
      )}
    </>
  );
};

export default PitchDeckTableRowView;
